<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("routes.trip_categories") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="dialog = !dialog" large class="primary">
        {{ $t("button.create") }}
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="trip-categories"
      resName="trip_categories"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          <v-avatar
            style="cursor: pointer"
            size="40"
            @click="showImagePreview(item.photo)"
          >
            <v-img :src="item.photo && item.photo.path" />
          </v-avatar>
        </td>
        <td class="text-sm-center">{{ item.name }}</td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="trip-categories"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>

        <td class="text-sm-center">
          <v-btn icon color="info" @click.stop="editCategory(item, index)">
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon
              color="error"
              @click="handleDelete(item, index)"
              :title="$t('icon.delete')"
              small
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
    <!-- dialog form -->
    <FormAction
      :loading.sync="loading"
      :slug="slugItem"
      :isEdit="isEdit"
      :dialog.sync="dialog"
      @on-create-category="onCreateCategory"
      @on-update-category="onUpdateCategory"
      @on-refresh-category="onRefreshCategory"
    />
    <!-- dialog form -->
    <!-- Image Preview -->
    <global-image-preview
      :showDialog.sync="imageOverlay"
      :imagePath="currentPreviewImage"
      @closePreview="imageOverlay = false"
    />
    <!-- Image Preview -->
  </main>
</template>

<script>
export default {
  name: "Categories",
  components: {
    FormAction: () => import("./FormAction")
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      slugItem: "",
      imageOverlay: false,
      dialog: false,
      headers: ["photo", "name", "visible", "actions"],
      currentPreviewImage: "",
      categoryIndex: ""
    };
  },
  methods: {
    onRefreshCategory() {
      this.$refs.table_ref.handleGetItems();
    },
    onCreateCategory(category) {
      this.$refs.table_ref
        .handleOnCreate("trip-categories", category, "trip_category")
        .then(() => {
          this.dialog = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdateCategory(category) {
      this.$refs.table_ref
        .handleOnEdit(
          "trip-categories",
          category,
          this.slugItem,
          "trip_category",
          this.categoryIndex
        )
        .then(() => {
          this.dialog = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editCategory(item, index) {
      this.isEdit = true;
      this.dialog = true;
      this.parent_id = item.id.toString();
      this.slugItem = item.slug;
      this.categoryIndex = index;
    },
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image.path;
        this.imageOverlay = true;
      }
    },
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    }
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.isEdit = false;
          this.slugItem = "";
        }
      },
      immediate: true
    }
  }
};
</script>
